import { call, put, select } from 'redux-saga/effects';

import request from '../request';
import selectors from '../../../selectors';
import actions from '../../../actions';
import api from '../../../api';

export function* fetchCardPointAdvancedDataInCurrentCard() {
  const card = yield select(selectors.selectCurrentCard);
  const pointSystem = yield select(selectors.selectPointSystemForCurrentBoard);

  if (!card || !pointSystem) {
    return;
  }

  yield put(actions.fetchCardPointAdvancedData(card.id));

  let items;
  try {
    ({ items } = yield call(request, api.getCardPointAdvancedData, card.id));
  } catch (error) {
    yield put(actions.fetchCardPointAdvancedData.failure(card.id, error));
    return;
  }

  yield put(actions.fetchCardPointAdvancedData.success(card.id, pointSystem.id, items || []));
}

export function* createCardPointAdvancedDataInCurrentCard() {
  const card = yield select(selectors.selectCurrentCard);
  const pointSystem = yield select(selectors.selectPointSystemForCurrentBoard);

  if (!card || !pointSystem) {
    return;
  }

  yield put(actions.createCardPointAdvancedData(card.id, {}));

  let item;
  try {
    ({ item } = yield call(request, api.createCardPointAdvancedData, card.id, {}));
  } catch (error) {
    yield put(actions.createCardPointAdvancedData.failure(card.id, error));
    return;
  }

  yield put(actions.createCardPointAdvancedData.success(item));
}

export function* updateCardPointAdvancedData(id, data) {
  yield put(actions.updateCardPointAdvancedData(id, data));

  let item;
  try {
    ({ item } = yield call(request, api.updateCardPointAdvancedData, id, data));
  } catch (error) {
    yield put(actions.updateCardPointAdvancedData.failure(id, error));
    return;
  }

  yield put(actions.updateCardPointAdvancedData.success(item));
}

export function* deleteCardPointAdvancedData(id) {
  yield put(actions.deleteCardPointAdvancedData(id));

  let item;
  try {
    ({ item } = yield call(request, api.deleteCardPointAdvancedData, id));
  } catch (error) {
    yield put(actions.deleteCardPointAdvancedData.failure(id, error));
    return;
  }

  yield put(actions.deleteCardPointAdvancedData.success(item));
}

export default {
  fetchCardPointAdvancedDataInCurrentCard,
  createCardPointAdvancedDataInCurrentCard,
  updateCardPointAdvancedData,
  deleteCardPointAdvancedData,
};

